// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"b76d97f1","325":"d0b6e8dc","787":"952f0a37","876":"954ad594","970":"dcadf996"}[chunkId] + ".chunk.js";
};